// extracted by mini-css-extract-plugin
export default {"container":"login_container__7gJR4","card":"login_card__kRKje","logo":"login_logo__MlWaT"};